import { makeStyles } from 'tss-react/mui'

export default makeStyles()(theme => ({
  container: {
    flexGrow: '1',
    position: 'relative !important' as 'relative',
    zIndex: '4 !important',
    marginBottom: `${theme.spacing(8)} !important`,
    transition: 'max-width 0.4s ease',
    minHeight: 800,
    width: '100%',
    minWidth: 0,
    [theme.breakpoints.up('md')]: {
      marginBottom: `${theme.spacing(16)} !important`,
    },
  },
}))
